import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/services';

@Component({
  selector: 'app-settings-auth',
  templateUrl: './settings-auth.component.html',
  styleUrls: ['./settings-auth.component.css'],
})
export class SettingsAuthComponent implements OnInit, OnDestroy {
  isWorking: boolean;
  isAuthenticated = false;
  private sub: any;

  constructor(
    public auth: AuthService
  ) {
    this.isAuthenticated = this.auth.isAuthenticated();

    this.auth.onAuthentication.subscribe((token) => {
      this.isAuthenticated = this.auth.isAuthenticated();
    });

  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/settings-auth/settings-auth.component.ts